import styled from 'styled-components';

export const CommonBlock = styled.div`
  max-width: 100%;
  background-color: #fff;
  padding: 0px 32px 32px 32px;
  margin: 8px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .p__link {
    margin-top: 16px;
    color: #161d1f;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  @media (min-width: 640px) {
    width: 97%;
  }

  p.errorPopup1 {
    font-weight: normal;

    a {
      color: #5b36f2;
      font-weight: bold;
    }
  }
`;

export const BlockPhoto = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 0px 16px;
`;

export const ButtonRequest = styled.button`
  align-items: center;
  background-color: #5b36f2;
  padding: 10px 16px;
  border-radius: 4px;
  margin: 40px 15px 0px 0px;
  width: 100%;

  p {
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    text-align: center;
  }

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const ButtonCancel = styled.button`
  align-items: center;
  background-color: #ffffff;
  padding: 10px 16px;
  border: 1px solid #5b36f2;
  border-radius: 4px;
  margin: 15px 0px 0px 0px;
  width: 100%;

  p {
    color: #5b36f2;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    text-align: center;
  }

  @media (min-width: 640px) {
    width: auto;
    margin-top: 40px;
  }
`;

export const ButtonContainer = styled.div`
  margin-left: 0px;
  @media (min-width: 640px) {
    margin-left: 50px;
  }
`;

export const ButtonContainerNoFoto = styled.div`
  margin-left: 0px;
  @media (min-width: 640px) {
    margin-left: -2px;
    display: flex;
  }
`;

export const ButtonContainerWrongPeriod = styled.div`
  margin-left: 0px;
  @media (min-width: 640px) {
    margin: 0px -14px 0px 0px;
  }
`;

export const DataInfo = styled.div`
  color: #161d1f;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 15px;

  ul {
    list-style-type: disc;
    list-style-position: inside;
    margin-left: 9px;

    li span {
      position: relative;
      left: -8px;
    }
  }
`;
